export const ROOT_PATH = '/'
export const EVENTS_PATH = '/streams'
export const NEW_EVENT_PATH = '/events/new'
export const QUICK_OVERLAYS_PATH = '/overlays'
export const CONNECTIONS_PATH = '/connections'
export const ASSETS_PATH = '/assets'
export const ADMIN_PATH = '/admin'
export const ADMIN_STREAMS_PATH = '/admin/streams'
export const USAGE_PATH = '/usage'
export const SETTINGS_PATH = '/settings'
export const ACCOUNT_PATH = '/settings/account'
export const BILLING_PATH = '/billing'

export const TERMS_PATH = 'https://www.stagepilot.com/legal/terms-of-use'
export const PRIVACY_PATH = 'https://www.stagepilot.com/legal/privacy'
export const SUPPORT_PATH = '/support'

export const SHOPIFY_CONNECTED_PATH = '/shopify/connected'

export const isShopifyConnectedPath = (pathname: string): boolean =>
  pathname === SHOPIFY_CONNECTED_PATH

export const isPublicHomePath = (pathname: string): boolean =>
  pathname === ROOT_PATH

export const showsPublicHome = ({
  pathname,
  isLoading,
  isAuthenticated
}: {
  pathname: string
  isLoading: boolean
  isAuthenticated: boolean
}): boolean =>
  !isLoading && !isAuthenticated && isPublicHomePath(pathname)

export const eventPath = (eventId: string): string => `/events/${eventId}`
export const eventSectionPath = (eventId: string, section: string): string => `/events/${eventId}/${section}`

export const OVERLAY_PATH_PREFIX = '/overlay/'

export const ACCOUNT_OVERLAY_PATH_PREFIX = '/o/'

export const accountChatOverlayPath = (chatId: string): string =>
  `${ACCOUNT_OVERLAY_PATH_PREFIX}chat/${chatId}`

export const accountEmoteWallOverlayPath = (emoteWallId: string): string =>
  `${ACCOUNT_OVERLAY_PATH_PREFIX}emotes/${emoteWallId}`

export const accountMerchOverlayPath = (merchOverlayId: string): string =>
  `${ACCOUNT_OVERLAY_PATH_PREFIX}merch/${merchOverlayId}`

export const KEY_OVERLAY_PATH_PREFIX = '/k/'

export const keyOverlayPath = (k: string): string =>
  `${KEY_OVERLAY_PATH_PREFIX}${k}`

export type OverlayKind = 'composite' | 'composite-mobile' | 'camctl'

export const overlayPath = (slug: string, kind: OverlayKind): string =>
  `${OVERLAY_PATH_PREFIX}${slug}/${kind}`

export const camControlOverlayPath = (slug: string, camControlId: string): string =>
  `${overlayPath(slug, 'camctl')}/${camControlId}`

export type CompositeOverlayKind = 'DESKTOP' | 'MOBILE'

export const COMPOSITE_OVERLAY_KINDS: CompositeOverlayKind[] = ['DESKTOP', 'MOBILE']

export const COMPOSITE_OVERLAY_SEGMENT: Record<CompositeOverlayKind, OverlayKind> = {
  DESKTOP: 'composite',
  MOBILE: 'composite-mobile'
}

export const compositeOverlayPath = (slug: string, kind: CompositeOverlayKind): string =>
  overlayPath(slug, COMPOSITE_OVERLAY_SEGMENT[kind])

export const isOverlayPath = (pathname: string): boolean =>
  pathname.startsWith(OVERLAY_PATH_PREFIX) ||
  pathname.startsWith(ACCOUNT_OVERLAY_PATH_PREFIX) ||
  pathname.startsWith(KEY_OVERLAY_PATH_PREFIX)

export type EventSection =
  | 'overview'
  | 'integrations'
  | 'polls'
  | 'trivia'
  | 'scoreboard'
  | 'tug-of-wars'
  | 'access'
  | 'desktop-overlay'
  | 'mobile-overlay'
  | 'chats'
  | 'emote-walls'
  | 'camera-controls'
  | 'giveaways'
  | 'message-tickers'

export const EVENT_SECTIONS: EventSection[] = [
  'overview',
  'integrations',
  'polls',
  'trivia',
  'scoreboard',
  'tug-of-wars',
  'access',
  'desktop-overlay',
  'mobile-overlay',
  'chats',
  'emote-walls',
  'camera-controls',
  'giveaways',
  'message-tickers'
]
